// Shim de interop jQuery×selectize p/ o Vite/Rollup (risco nº 3 da checklist de migração).
// O selectize (plugin jQuery CJS de 2016) se registra em window.jQuery/$ como efeito
// colateral no import. No webpack (CJS) a ordem dos imports tolerava; o interop ESM do
// Rollup pode hoistar/reordenar e o plugin não encontra o jQuery → "$(...).selectize is
// not a function". Este módulo é importado ANTES de qualquer 'selectize' (entry e
// componentes) e garante o global.
import $ from "jquery";

declare global {
  interface Window {
    jQuery: typeof $;
    $: typeof $;
  }
}

window.jQuery = $;
window.$ = $;

export default $;
